// extracted by mini-css-extract-plugin
module.exports = {"info":"page_info__TiFwr","list":"page_list__UV4SQ"};